import { toast } from 'vue-sonner'

import { useEmitter } from './useEmitter'

export const useNotify =
  () =>
  (
    text: string,
    mode: 'error' | 'success' | 'info' | 'warning',
    options: {
      onClose?: () => void
      context?: 'root' | 'settings'
    } = {}
  ): void => {
    const { context = 'root', ...restOptions } = options

    switch (context) {
      case 'settings': {
        let toastMode
        switch (mode) {
          case 'error':
            toastMode = 'danger'
            break
          case 'info':
            toastMode = 'neutral'
            break
          case 'success':
            toastMode = 'success'
            break
          case 'warning':
            toastMode = 'warning'
            break
          default:
            mode satisfies never
        }
        useEmitter.emit('settings-notification', {
          mode: toastMode,
          text,
          ...restOptions,
        })
        break
      }
      case 'root': {
        const onDismiss = restOptions.onClose
        switch (mode) {
          case 'success':
            toast.success(text, { onDismiss })
            break
          case 'error':
            toast.error(text, { onDismiss })
            break
          case 'warning':
            toast.warning(text, { onDismiss })
            break
          case 'info':
            toast.info(text, { onDismiss })
            break
          default:
            toast(text, { onDismiss })
        }
        break
      }
      default:
        context satisfies never
    }
  }
